import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SubscriptionBanner from '../../components/SubscriptionBanner';
import { UserContext } from '../../context/UserContext';
import { Role } from '@redpanda/types';

const AdminPage: React.FC = () => {
  const { t } = useTranslation('translation');
  const userContext = useContext(UserContext);
  const userRole = userContext?.user?.role;
  const navigate = useNavigate();

  useEffect(() => {
    if (userRole !== Role.SUPER_ADMIN) {
      navigate('/');
    }
  }, [userRole, navigate]);

  if (userRole !== Role.SUPER_ADMIN) {
    return null;
  }

  return (
    <div className="container mx-auto px-4 md:px-10 py-6 pb-32">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
          {t('queue.admin.title')}
        </h1>
      </div>

      {/* 訂閱橫幅 */}
      <SubscriptionBanner />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
        {/* Subscription Management Section */}
        <div>
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-4">
            {t('queue.admin.subscriptionManagement.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            {t('queue.admin.subscriptionManagement.description')}
          </p>
          <a
            href={`${process.env.REACT_APP_ACCOUNT_PORTAL_URL || 'http://localhost:8003'}/queue`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded transition-all duration-200"
          >
            {t('queue.admin.subscriptionManagement.button')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminPage;
